angular.module('bmsApp.dashboard')
	.controller('EmployeeTrainingDashboardCtrl', EmployeeTrainingDashboardCtrl);

EmployeeTrainingDashboardCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'SharedTrainingSvc',
];

function EmployeeTrainingDashboardCtrl(
	$scope,
	$state,
	$q,
	SharedTrainingSvc,
) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: true,
		handlers: handlers,
		page: 1,
		filter: {
			status: 'outstanding',
		},
	});

	this.$onInit = () => {
		loadEmployeeTraining();
	};

	function loadEmployeeTraining() {
		self.loading = true;
		let params = {
			page: self.page,
			count: 20,
			filter: {
				employeeCourse: true,
				employeeCompleted: self.filter.status !== 'outstanding',
				search: self.filter.search,
			},
		};

		return SharedTrainingSvc.index(params).then((response) => {
			self.userCourses = response.data.course_collection;
			self.totalUserCourses = response.data.count;
			self.loading = false;
		});
	}

	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.showTrainingModal = (userCourse) => {
		SharedTrainingSvc.showTrainingModal(userCourse).then((result) => {

		});
	};

	handlers.statusChanged = (status) => {
		self.filter.status = status;
		loadEmployeeTraining();
	};
}
